import store from '@/store'
import moment from 'moment';
import CONST from './const';
import mobileDetect from './mobileDetect';


export default class Utils {
  static log(name, data) {
    console.log(`${name}`, data)
  }

  static isEmptyObject(obj) {
    return obj === null || obj === undefined ||
      (obj.constructor === Object && Object.keys(obj).length === 0) || // {} empty object(empty json)
      (Array.isArray(obj) && obj.length === 0) || // [] empty array
      this.isEmptyString(obj)
  }

  static isEmptyString(str) {
    return str === null || str === undefined || str === ''
  }

  static objectSize(obj) {
    if (this.isEmptyObject(obj)) {
      return 0;
    }

    return Object.keys(obj).length
  }

  static setApiResponsSuccess(resp) {
    resp.success = resp.status ? resp.status >= 200 && resp.status < 300 : false
  }

  static getParamFromURL(key) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(key)
  }
  static getLastestTime(date){
    return moment(date).startOf('m').toISOString();
  }

  static setEventDataTimeDesc(data){
    data.sort((a, b) => {
      const dateA = new Date(a.eventTime);
      const dateB = new Date(b.eventTime);
      return dateB - dateA;
    });
  }

  static setEventDataTimeAsc(data){
    data.sort((a, b) => {
      const dateA = new Date(a.eventTime);
      const dateB = new Date(b.eventTime);
      return dateA - dateB;
    });
  }


  static isGetData = false
  static async getDataFirstLogin() {
    if(this.isGetData) {
      return 
    }
    console.log('getDataFirstLogin()')
    store.dispatch('trafficCCTV/updateTrafficCCTVs')
    store.dispatch('passengerEstimateSetting/getEstimate')
    await store.dispatch('disasterSettingDBModal/getDisasters')
    await store.dispatch('scenicArea/getScenicArea', {id: -1})
    await store.dispatch("roleToScenicArea/getAllRoleScenicAreaId");
    await store.dispatch('videoCamera/getCCTV')
    store.dispatch('deviceApi/getDevice', {deviceType: ''})
    store.dispatch('peculiarSmell/getPeculiarSmell')
    store.dispatch('handSanitizer/getHandSanitizer')
    store.dispatch('emergencyEvent/getEmergencyButton')
    // store.dispatch('weatherStation/updateSanxianStationData')
    await store.dispatch('holidaySetting/getHolidays')
    store.dispatch('mobileDetect/getIsIOSDevice')
    
    this.isGetData = true
  }

  static getCctvPlayerType(cctv) {
      let result = false
      if(cctv.id ) {
        result = CONST.MJPEG_DEVICE_ID.includes(cctv.id)
      }

      if(cctv.type === CONST.MAP_ICON_TYPE.TRFFIC) {
        result = true
      }

      if(result) {
        return CONST.PLAYER_TYPE.MJPEG
      } else {
        return CONST.PLAYER_TYPE.FLV
      }
  }

  static transElkImgHyperLink(imgUrl) {
    if(this.isEmptyObject(imgUrl) ||window.location.protocol === 'http:') {
      return imgUrl
    }

    const domainName = window.location.host
    let url = imgUrl

    if(domainName === CONST.EXTRA_DOMAIN_NAME) {
      if(imgUrl.includes('http://10.179.2.35:8888/')) { // 舊elk車牌圖片是2.35
        url = imgUrl.replace('http://10.179.2.35:8888/', 'https://imts.eastcoast-nsa.gov.tw/elkimage/')

      } else if(imgUrl.includes('http://10.179.20.35:8888/')) { // 新elk車牌圖片是20.35
        url = imgUrl.replace('http://10.179.20.35:8888/', 'https://imts.eastcoast-nsa.gov.tw/elkimage/')

      }
    }

    return url  
  }

  static transElkImgByNginx(imgUrl) {
    //http 則使用elk原本的圖片連結,否則改為nginx導址
    // http://10.179.2.35:8888/api/Media/EventImage/f06ec5e0-60d8-11ed-bc70-ac1f6b3cc
    // https://10.179.2.35/elkimage/api/Media/EventImage/f06ec5e0-60d8-11ed-bc70-ac1f6b3cc

    if(this.isEmptyObject(imgUrl) ||window.location.protocol === 'http:') {
      return imgUrl
    }
      
    const domainName = window.location.host
    let url = imgUrl

    if (domainName === CONST.EXTRA_DOMAIN_NAME) {
      if (imgUrl.includes('http://10.179.2.35:8888/')) { // 舊elk車牌圖片是2.35
        url = imgUrl.replace('http://10.179.2.35:8888/', 'https://imts.eastcoast-nsa.gov.tw/elkimage/')

      } else if (imgUrl.includes('http://10.179.20.35:8888/')) { // 新elk車牌圖片是20.35
        url = imgUrl.replace('http://10.179.20.35:8888/', 'https://imts.eastcoast-nsa.gov.tw/elkimage/')

      }
    } else if (domainName === CONST.BACKUP_IP) {
      if (imgUrl.includes('http://10.179.2.35:8888/')) { // 舊elk車牌圖片是2.35
        url = imgUrl.replace('http://10.179.2.35:8888/', 'https://10.179.3.10/elkimage/')

      } else if (imgUrl.includes('http://10.179.20.35:8888/')) { // 新elk車牌圖片是20.35
        url = imgUrl.replace('http://10.179.20.35:8888/', 'https://10.179.3.10/elkimage/')

      }
    }

    return url
  }

  static getScenicAreaIdFromUrlPath() {
    return window.location.pathname.split('/').pop()
  }

  static isShowWeatherScenicArea(sc) {
    return this.isEmptyObject(sc) || this.isEmptyObject(sc.additionInfo) ? true : (sc.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.WEATHER_INFO)
  }

  static isShowCloseInScenicArea(sc) {
    return this.isEmptyObject(sc) || this.isEmptyObject(sc.additionInfo) ? true : (sc.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CLOSE_IN_ADVANCE)
  }

  static handleDeviceLntLng(device) {
    if(Utils.isEmptyObject(device.latitude) || Utils.isEmptyObject(device.longitude)) {
      device[CONST.TRAFFIC_CCTV_KEY.CENTER] = null
    } else {
      device[CONST.TRAFFIC_CCTV_KEY.CENTER] = {
        lat: device.latitude,
        lng: device.longitude
      }
    }

    return device
  }

  static getESQueryStreamingId(streamingIds) {
    return streamingIds.map(sid => `StreamID:"${sid}"`).join(' OR ')
  }

  static getESQueryOdorNiloId(deviceIds) {
    return deviceIds.map(did => `message.device.sn:"${did}"`).join(' OR ')
  }

  static getESQueryByObjectType(objectTypes) {
    let typeString = '' // query: `( ${type1} ) OR ( ${type2} )`
    if (this.isEmptyObject(objectTypes)) {
      return typeString
    }

    for (let i = 0; i < objectTypes.length; i++) {
      typeString = typeString + '(' + objectTypes[i] + ')'
      if (i < objectTypes.length - 1) {
        typeString = typeString + ' OR '
      }
    }

    return typeString
  }

  static genUUID() {
    // 00000000-0000-0000-0000-000000000000 empty
    var d = Date.now();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  static checkUUIDformat(uuid) {
    const regexExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    return regexExp.test(uuid)
  }

  static setScenicAreaNamebyId(dataList =[]) {
    const scenicAreaList = store.getters['scenicArea/getAllScenicArea']

    for(let i = 0 ; i < dataList.length ; i++){
      let target = scenicAreaList.find(sa => sa.id === dataList[i].scenicAreaId)
      dataList[i].ScenicAreaName = target? target.name : ''
    }
  }

  static setPublicPlaceTypebyData(dataList=[]){
    const publicPlaceType = CONST.EAST_COAST_PUBLIC_PLACE_TYPE;

    for(let i = 0 ; i < dataList.length ; i++){
      let target = publicPlaceType.find(sa => sa.enumType === dataList[i].operationType)
      dataList[i].operationTypeName = target? target.description : ''
    }
  }

  static getSingleScenicAreaNamebyId(data){
    const scenicAreaList = store.getters['scenicArea/getAllScenicArea']
    let target =  scenicAreaList.find (sa => sa.id === data)
    return target.name
  }


  static setDisasterContent(dataList =[]) {
    for(let i = 0 ; i < dataList.length ; i++){
       dataList[i].dismissContent= dataList[i].content 
    }
  }

  static setControlData(dataList =[]){
    for(let i = 0 ; i < dataList.length ; i++){
      dataList[i].eventTime = dataList[i].changeTime;
      dataList[i].dismissContent = dataList[i].controlswitch
      if(dataList[i].dismissContent === true){
        dataList[i].dismissContent = "開啟管制"
      }else if(dataList[i].dismissContent === false){
        dataList[i].dismissContent = "解除管制"
      }
   }
  }



  static setVehicleStreamName(dataList = [], isInternal = true) {
    if (this.isEmptyObject(dataList)) {
      return
    }

    const cctvList = store.getters['videoCamera/getVehicleCCTVData']
    this.setStreamingNameAndScenicAreaNamebyId(dataList, cctvList, isInternal)
  }

  static setToiletStreamName(dataList = [], isInternal = true) {
    if (this.isEmptyObject(dataList)) {
      return
    }

    const cctvList = store.getters['videoCamera/getToiletPersonFlowCCTVData']
    this.setStreamingNameAndScenicAreaNamebyId(dataList, cctvList, isInternal)
  }

  static setStreamingNameAndScenicAreaNamebyId(dataList = [], cctvList = [], isInternal = true) { //elk data set streeaming name
    if (this.isEmptyObject(dataList) || this.isEmptyObject(cctvList)) {
      return
    }

    let carTypeEnum =[]
    if(isInternal) {
      carTypeEnum = store.getters['passengerEstimateSetting/getInternalEstimateWeight']
    } else {
      carTypeEnum = store.getters['passengerEstimateSetting/getExternalEstimateWeight']
    }
    
    for (let i = 0; i < dataList.length; i++) {
      let target = cctvList.find(cctv => cctv.streamId === dataList[i]._source.StreamID)

      // // 芭崎出口現在是用入口的辨識串流
      // dataList[i]._source.StreamName = target ? target.name : dataList[i]._source.StreamID === 'cd401787-7109-4fb8-a709-30270efbc9a2' ? '槍型攝影機(車 out)' :''
      // dataList[i]._source.ScenicAreaName = target ? target.scenicAreaName : dataList[i]._source.StreamID === 'cd401787-7109-4fb8-a709-30270efbc9a2' ? '芭崎' :''
      // dataList[i]._source.PublicPlaceName = target ? target.publicPlaceName : dataList[i]._source.StreamID === 'cd401787-7109-4fb8-a709-30270efbc9a2' ? '休息區出入口' : ''
      // dataList[i]._source.direct = target? target.videoPurposeType === 'vehicleIn' ? '進入' : '離開' : dataList[i]._source.StreamID === 'cd401787-7109-4fb8-a709-30270efbc9a2' ? '離開' :'unknow'

      dataList[i]._source.StreamName = target ? target.name :''
      dataList[i]._source.ScenicAreaName = target ? target.scenicAreaName:''
      dataList[i]._source.PublicPlaceName = target ? target.publicPlaceName  : ''
      dataList[i]._source.direct = target ? (target.videoPurposeType === 'vehicleIn' ? '進入' : '離開') : 'unknow';

      
      const carEnum = carTypeEnum.find( e => e.enumType === dataList[i]._source.ObjectType)
      const holidayMap = store.getters['holidaySetting/getHolidayMap']
      const date = moment(dataList[i]._source.OccurrenceTime).startOf('day').format().split('+')[0]
      const isHoliday = holidayMap.get(date)
      dataList[i]._source.weight = carEnum ? isHoliday? carEnum.holidayWeight : carEnum.weight : 'unknow'
      dataList[i]._source.dayType = isHoliday? CONST.ESTIMATE_DAT_TYPE.holiday : CONST.ESTIMATE_DAT_TYPE.ordinaryDay
    }
  }

  static setNiloDeviceName(dataList = []) {
    if (this.isEmptyObject(dataList)) {
      return
    }

    const deviceList = store.getters['handSanitizer/getAllHandSanitizer']
    this.setDeviceNameAndScenicAreaNamebyId(dataList, deviceList)
  }

  static setOdorDeviceName(dataList = []) {
    if (this.isEmptyObject(dataList)) {
      return
    }

    const deviceList = store.getters['peculiarSmell/getAllPeculiarSmell']
    this.setDeviceNameAndScenicAreaNamebyId(dataList, deviceList)
  }

  static setDeviceNameAndScenicAreaNamebyId(dataList = [], deviceList = []) { //elk data set odor and nilo name
    if (this.isEmptyObject(dataList) || this.isEmptyObject(deviceList)) {
      return
    }

    for (let i = 0; i < dataList.length; i++) {
      let target = deviceList.find(device => device.id === dataList[i]._source.message.device.sn)
      dataList[i]._source.StreamName = target ? target.name : '異味偵測器'
      dataList[i]._source.ScenicAreaName = target ? target.scenicAreaName : '三仙台'
      dataList[i]._source.PublicPlaceName = target ? target.publicPlaceName : 'T08大停車場公廁(男)'
      dataList[i]._source.PublicPlaceId = target ? target.publicPlaceId : '57'
    }
  }

  static arrayGroupBy(array, groupKey, objectKey) {
    if(!Array.isArray(array)) {
      return []
    }

    Array.prototype.groupBy = function (prop) {   //自定義一個groupBy函數
      return this.reduce(function (groups, item) {
        const val = item[prop]
        groups[val] = groups[val] || []
        groups[val].push(item)
        return groups
      }, {})
    };

    const groupBy = array.groupBy(groupKey) // 使用自定義的groupBy函數
    let result = Object.keys(groupBy).map((key) => {
      const val = {}
      val[groupKey] = key
      val[objectKey] = groupBy[key]
      return val
    });

    return result
  }

  static mapReduceControlStatus(statusArray) {
    if(this.isEmptyObject(statusArray)) {
      return {}
    }

    let controlChangeTime = '' // for儀錶板可以找到修改管制時間，首頁忽略(會出現最後景區的修改管制時間，用不到)
    const controlStatus = statusArray.map((c) => {
      const status = {}
      status[c.controlHistoryType] = c.controlswitch
      if(c.controlHistoryType === CONST.CONTROL_TYPE.CONTROL) {
        controlChangeTime = c.changeTime
      }
      return status
    }).reduce((accumulate, c) => (
      {...accumulate, [Object.keys(c)[0]]: c[Object.keys(c)[0]]}
    ))

    controlStatus.time = controlChangeTime
    return controlStatus
  }


  static getViolationType(string) {
    if(Utils.isEmptyObject(string)) {
      return '-'
    }
  
    return string === 'person' ? '預警封閉' : '機車闖入'
  }

  // 折線圖只有一個點的時候，前後補0
  static setapexChartZero(xaxis, data) {
    const xaxisCategories = [moment(xaxis[0]).add(-1, "days").format("YYYY-MM-DD HH:mm")].concat(xaxis).concat([moment(xaxis[0]).add(1, "days").format("YYYY-MM-DD HH:mm")])
    // xaxis的type改為datetime， 所以需要改成時間型態資料    
    const chartData = data.map(e => {
      e.data = [0].concat(e.data).concat([0])
      return e
    })

    return {xaxisCategories, chartData}
  }

  static setapexChartZeroType(xaxis, data, type) {
    // xaxis的type改為datetime， 所以需要改成時間型態資料
    const xaxisCategories = [
      moment(xaxis[0]).startOf(type).format("YYYY-MM-DD HH")]
    .concat(xaxis)
    .concat(moment(xaxis[0]).endOf(type).format("YYYY-MM-DD HH:mm"));

    
    const chartData = data.map(e => {
      e.data = [0].concat(e.data).concat([0])
      return e
    })

    return {xaxisCategories, chartData}
  }

  static setapexChartZeroDayType(xaxis, data) {
    const xaxisCategories = [
      moment(xaxis[0]).startOf("day").format("MM-DD HH")]
    .concat(xaxis)
    .concat(moment(xaxis[0]).endOf("day").format("MM-DD HH"));

    
    const chartData = data.map(e => {
      e.data = [0].concat(e.data).concat([0])
      return e
    })

    return {xaxisCategories, chartData}
  

    
  }

  //將西元紀年搭配 moment.js 轉換為民國紀年
  static convertToTaiwanYear(date) {
    if (Utils.isEmptyObject(date)) {
      return ''
    }
    const taiwanYear = moment(date).year() - 1911;
  
    return taiwanYear
}
  //將流水號設定為三位數
  static formatThreeDigits(item){
    return item.toString().padStart(3, '0')
  }

}

let siteConfig
export async function getSiteConfig(){

  if(!siteConfig){
    const resp = await fetch('/config.json')
    const data=await resp.json()
    siteConfig = data
  }
  return siteConfig
}

export async function getRelayMapping(cctv){
  console.log("getRelayMapping",cctv);
  const originalUrl = cctv[CONST.TRAFFIC_CCTV_KEY.URL]
  if(Utils.isEmptyObject(originalUrl)){
    return originalUrl
  }
  // console.log("Utils.cctve",cctv);
  const cctvType = Utils.getCctvPlayerType(cctv)
  // console.log("Utils.cctvType",cctvType);

  const urlSplit = originalUrl.split('/') // ws://10.179.150.10:8089/NVR/cv01011   // http://61.222.211.43:8080/?FUN=Video&CH=002
  const targetString = urlSplit[2] // ['ws:', '', '10.179.150.10:8089', 'NVR', 'cv01011']  // ['http:', '', '61.222.211.43:8080', '?FUN=Video&CH=002']

  const domainName = window.location.host
  const relayMapping = domainName === CONST.EXTRA_DOMAIN_NAME ? (await getSiteConfig()).extraRelayMapping : 
    domainName === CONST.VPN_DOMAIN_NAME ? (await getSiteConfig()).vpnMapping : 
    domainName === CONST.EXTRA_IP_DOMAIN_NAME? (await getSiteConfig()).extraIpRelayMapping : (await getSiteConfig()).relayMapping
  const mappingResult  = relayMapping.find(m=>targetString.indexOf(m.originalHostname)>=0)

  if(Utils.isEmptyObject(mappingResult)) {
    return originalUrl
  } else {

    if(cctvType === CONST.PLAYER_TYPE.FLV) {
      //ws://192.168.50.85:8089/NVR/ch53
      //http://192.168.50.85:8092/ch53/index.m3u8

      if(mobileDetect.isIosMobile()) {

      }
      // if(cctv.scenicAreaName == "八仙洞") {
      //   //八仙洞 測試 HLS 格式用
      //   console.log("cctvType",cctv)
      //   return 'https://'+ mappingResult.mappingPath +'/'+ urlSplit[3] +'/'+ urlSplit[4]+'/'+'live.m3u8';
  
      // }else{
        return 'wss://'+ mappingResult.mappingPath +'/'+ urlSplit[3] +'/'+ urlSplit[4]
      // }

    }else {
      // CONST.PLAYER_TYPE.MJPEG
      return 'https://'+ mappingResult.mappingPath +'/'+ urlSplit[3]
    }    
  }
}

export async function getActivityCemeraId(){
  const ids = (await getSiteConfig()).Activity_Camera
  return ids
}

